import { useMemo } from "react";
import { useGetBonusesQuery } from "@/queries/useGetBonusesQuery";

interface BonusItem {
  id: string;
  name: string;
  balance: number;
}

export const useBonuses = () => {
  const { data, isLoading, isError } = useGetBonusesQuery();
  const bonusesData = (data || []) as BonusItem[];

  const primaryBonus = useMemo(() => {
    if (bonusesData.length === 0) return null;
    const top = bonusesData.reduce((prev, current) =>
      current.balance > prev.balance ? current : prev
    );
    return { ...top, formattedBalance: top.balance.toLocaleString("ru-RU") };
  }, [bonusesData]);

  return {
    bonusesData,
    primaryBonus,
    isLoading,
    isError,
    hasBonuses: bonusesData.length > 0,
  };
};
